import { render, staticRenderFns } from "./DeleteTask.vue?vue&type=template&id=28804d0d"
import script from "./DeleteTask.vue?vue&type=script&lang=ts"
export * from "./DeleteTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28804d0d')) {
      api.createRecord('28804d0d', component.options)
    } else {
      api.reload('28804d0d', component.options)
    }
    module.hot.accept("./DeleteTask.vue?vue&type=template&id=28804d0d", function () {
      api.rerender('28804d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/DeleteTask.vue"
export default component.exports